import React from "react";
import Routes from "./utils/routes";
import "bootstrap/dist/css/bootstrap.min.css";

const App = () => {
  return <Routes/>;
};

export default App;
